import { useState, useEffect } from 'react';
import { subscribeToErrorModal, closeErrorModal } from '../services/errorModalService';

export function useErrorModal() {
  const [state, setState] = useState({ isOpen: false, errorMessage: '', correlationId: '' });

  useEffect(() => {
    return subscribeToErrorModal(setState);
  }, []);

  return {
    isOpen: state.isOpen,
    errorMessage: state.errorMessage,
    correlationId: state.correlationId,
    onClose: closeErrorModal,
  };
}
